/* eslint-disable no-prototype-builtins */
import {Address, CustomAttribute, QuoteAddress, Region} from '@/store/models';
import {clone, cloneDeep, isArray, isInteger, isObject} from 'lodash';
import {findRegionById} from './regionFinder';

export default function addressNormalizer(address: Address | QuoteAddress): Address | QuoteAddress {
    const addressCopy1: Address | QuoteAddress = cloneDeep(address);
    const addressCopy = clone(addressCopy1);

    if (address) {
        if (isObject(addressCopy.region) && addressCopy.region !== null) {
            const regionObj = addressCopy.region as Region;
            addressCopy.region = regionObj.region;
            addressCopy.region_id = regionObj.region_id;
        } else if (isInteger(addressCopy.region)) {
            const regionId = addressCopy.region as number;
            addressCopy.region = findRegionById(regionId).region;
            addressCopy.region_id = regionId;
        } else if (isInteger(addressCopy.region_id) && addressCopy.region_id > 0) {
            const foundRegion = findRegionById(addressCopy.region_id);
            addressCopy.region = foundRegion ? foundRegion.region : '';
        } else {
            addressCopy.region = address.region;
            addressCopy.region_id = address.region_id;
        }

        if (typeof addressCopy.street === 'string') {
            const {street} = addressCopy;
            addressCopy.street = [street];
        }

        if (!addressCopy.country_id) {
            addressCopy.country_id = 'IT';
        }

        if (!address.hasOwnProperty('save_in_address_book') && address.id) {
            addressCopy.customer_address_id = address.id;
        }

        if (!addressCopy.hasOwnProperty('extension_attributes')) {
            addressCopy.extension_attributes = {};
        }

        if (addressCopy.hasOwnProperty('error')) {
            delete addressCopy.error;
        }

        delete addressCopy.default_billing;
        delete addressCopy.default_shipping;
    }

    return addressCopy;
}

export function quoteAddressToCustomerAddress(address: QuoteAddress): Address {
    const addressCopy = addressNormalizer(address) as any;

    if (isInteger(addressCopy.region_id)) {
        if (addressCopy.region_id > 0) {
            addressCopy.region = findRegionById(addressCopy.region_id);
        } else {
            addressCopy.region = {
                region: addressCopy.region,
                region_id: addressCopy.region_id,
            };
        }

        delete addressCopy.region.country_id;
    }

    if (addressCopy.hasOwnProperty('region_code')) {
        delete addressCopy.region_code;
    }

    if (addressCopy.hasOwnProperty('email')) {
        delete addressCopy.email;
    }

    if (addressCopy.hasOwnProperty('same_as_billing')) {
        delete addressCopy.same_as_billing;
    }

    if (addressCopy.hasOwnProperty('same_as_shipping')) {
        delete addressCopy.same_as_shipping;
    }

    if (addressCopy.hasOwnProperty('customer_address_id')) {
        addressCopy.id = addressCopy.customer_address_id;
        delete addressCopy.customer_address_id;
    }

    if (addressCopy.hasOwnProperty('save_in_address_book')) {
        delete addressCopy.save_in_address_book;
    }

    if (addressCopy.hasOwnProperty('error')) {
        delete addressCopy.error;
    }

    if (addressCopy.extension_attributes && addressCopy.extension_attributes.hasOwnProperty('discounts')) {
        delete addressCopy.extension_attributes.discounts;
    }

    return addressCopy as Address;
}

export function normalizeQuoteAddress(address: QuoteAddress): QuoteAddress {
    // eslint-disable-next-line no-param-reassign
    address = addressNormalizer(address) as QuoteAddress;

    if (!address.hasOwnProperty('custom_attributes')) {
        address.custom_attributes = {};
    }

    if (!address.hasOwnProperty('extension_attributes')) {
        address.extension_attributes = {};
    }

    if (address.extension_attributes && address.extension_attributes.hasOwnProperty('discounts')) {
        delete address.extension_attributes.discounts;
    }

    address.same_as_billing = 0;
    address.save_in_address_book = 0;

    return address;
}

export function addExtensionAttributes(address: Address): Address {
    if (!address.hasOwnProperty('custom_attributes')) {
        address.custom_attributes = {};
    }

    if (!address.hasOwnProperty('extension_attributes')) {
        address.extension_attributes = {};
    }

    if (address.hasOwnProperty('custom_attributes')) {
        if (isArray(address.custom_attributes)) {
            address.custom_attributes.forEach((a: CustomAttribute) => {
                address.extension_attributes[a.attribute_code] = a.value;
            });
        }

        // delete address.custom_attributes;
    }

    return address;
}

export function removeError(address: QuoteAddress): QuoteAddress {
    if (address.hasOwnProperty('error')) {
        delete address.error;
    }

    return address;
}
